const isBrowser = () => typeof window === "object" && typeof document === "object" && document.nodeType === 9;
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var dayjs_min = { exports: {} };
(function(module, exports) {
  !function(t, e) {
    module.exports = e();
  }(commonjsGlobal, function() {
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", f = "month", h = "quarter", c = "year", d = "date", $ = "Invalid Date", l = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_") }, m = function(t2, e2, n2) {
      var r2 = String(t2);
      return !r2 || r2.length >= e2 ? t2 : "" + Array(e2 + 1 - r2.length).join(n2) + t2;
    }, g = { s: m, z: function(t2) {
      var e2 = -t2.utcOffset(), n2 = Math.abs(e2), r2 = Math.floor(n2 / 60), i2 = n2 % 60;
      return (e2 <= 0 ? "+" : "-") + m(r2, 2, "0") + ":" + m(i2, 2, "0");
    }, m: function t2(e2, n2) {
      if (e2.date() < n2.date())
        return -t2(n2, e2);
      var r2 = 12 * (n2.year() - e2.year()) + (n2.month() - e2.month()), i2 = e2.clone().add(r2, f), s2 = n2 - i2 < 0, u2 = e2.clone().add(r2 + (s2 ? -1 : 1), f);
      return +(-(r2 + (n2 - i2) / (s2 ? i2 - u2 : u2 - i2)) || 0);
    }, a: function(t2) {
      return t2 < 0 ? Math.ceil(t2) || 0 : Math.floor(t2);
    }, p: function(t2) {
      return { M: f, y: c, w: o, d: a, D: d, h: u, m: s, s: i, ms: r, Q: h }[t2] || String(t2 || "").toLowerCase().replace(/s$/, "");
    }, u: function(t2) {
      return t2 === void 0;
    } }, v = "en", D = {};
    D[v] = M;
    var p = function(t2) {
      return t2 instanceof _;
    }, S = function t2(e2, n2, r2) {
      var i2;
      if (!e2)
        return v;
      if (typeof e2 == "string") {
        var s2 = e2.toLowerCase();
        D[s2] && (i2 = s2), n2 && (D[s2] = n2, i2 = s2);
        var u2 = e2.split("-");
        if (!i2 && u2.length > 1)
          return t2(u2[0]);
      } else {
        var a2 = e2.name;
        D[a2] = e2, i2 = a2;
      }
      return !r2 && i2 && (v = i2), i2 || !r2 && v;
    }, w = function(t2, e2) {
      if (p(t2))
        return t2.clone();
      var n2 = typeof e2 == "object" ? e2 : {};
      return n2.date = t2, n2.args = arguments, new _(n2);
    }, O = g;
    O.l = S, O.i = p, O.w = function(t2, e2) {
      return w(t2, { locale: e2.$L, utc: e2.$u, x: e2.$x, $offset: e2.$offset });
    };
    var _ = function() {
      function M2(t2) {
        this.$L = S(t2.locale, null, true), this.parse(t2);
      }
      var m2 = M2.prototype;
      return m2.parse = function(t2) {
        this.$d = function(t3) {
          var e2 = t3.date, n2 = t3.utc;
          if (e2 === null)
            return new Date(NaN);
          if (O.u(e2))
            return new Date();
          if (e2 instanceof Date)
            return new Date(e2);
          if (typeof e2 == "string" && !/Z$/i.test(e2)) {
            var r2 = e2.match(l);
            if (r2) {
              var i2 = r2[2] - 1 || 0, s2 = (r2[7] || "0").substring(0, 3);
              return n2 ? new Date(Date.UTC(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2)) : new Date(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2);
            }
          }
          return new Date(e2);
        }(t2), this.$x = t2.x || {}, this.init();
      }, m2.init = function() {
        var t2 = this.$d;
        this.$y = t2.getFullYear(), this.$M = t2.getMonth(), this.$D = t2.getDate(), this.$W = t2.getDay(), this.$H = t2.getHours(), this.$m = t2.getMinutes(), this.$s = t2.getSeconds(), this.$ms = t2.getMilliseconds();
      }, m2.$utils = function() {
        return O;
      }, m2.isValid = function() {
        return !(this.$d.toString() === $);
      }, m2.isSame = function(t2, e2) {
        var n2 = w(t2);
        return this.startOf(e2) <= n2 && n2 <= this.endOf(e2);
      }, m2.isAfter = function(t2, e2) {
        return w(t2) < this.startOf(e2);
      }, m2.isBefore = function(t2, e2) {
        return this.endOf(e2) < w(t2);
      }, m2.$g = function(t2, e2, n2) {
        return O.u(t2) ? this[e2] : this.set(n2, t2);
      }, m2.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, m2.valueOf = function() {
        return this.$d.getTime();
      }, m2.startOf = function(t2, e2) {
        var n2 = this, r2 = !!O.u(e2) || e2, h2 = O.p(t2), $2 = function(t3, e3) {
          var i2 = O.w(n2.$u ? Date.UTC(n2.$y, e3, t3) : new Date(n2.$y, e3, t3), n2);
          return r2 ? i2 : i2.endOf(a);
        }, l2 = function(t3, e3) {
          return O.w(n2.toDate()[t3].apply(n2.toDate("s"), (r2 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e3)), n2);
        }, y2 = this.$W, M3 = this.$M, m3 = this.$D, g2 = "set" + (this.$u ? "UTC" : "");
        switch (h2) {
          case c:
            return r2 ? $2(1, 0) : $2(31, 11);
          case f:
            return r2 ? $2(1, M3) : $2(0, M3 + 1);
          case o:
            var v2 = this.$locale().weekStart || 0, D2 = (y2 < v2 ? y2 + 7 : y2) - v2;
            return $2(r2 ? m3 - D2 : m3 + (6 - D2), M3);
          case a:
          case d:
            return l2(g2 + "Hours", 0);
          case u:
            return l2(g2 + "Minutes", 1);
          case s:
            return l2(g2 + "Seconds", 2);
          case i:
            return l2(g2 + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, m2.endOf = function(t2) {
        return this.startOf(t2, false);
      }, m2.$set = function(t2, e2) {
        var n2, o2 = O.p(t2), h2 = "set" + (this.$u ? "UTC" : ""), $2 = (n2 = {}, n2[a] = h2 + "Date", n2[d] = h2 + "Date", n2[f] = h2 + "Month", n2[c] = h2 + "FullYear", n2[u] = h2 + "Hours", n2[s] = h2 + "Minutes", n2[i] = h2 + "Seconds", n2[r] = h2 + "Milliseconds", n2)[o2], l2 = o2 === a ? this.$D + (e2 - this.$W) : e2;
        if (o2 === f || o2 === c) {
          var y2 = this.clone().set(d, 1);
          y2.$d[$2](l2), y2.init(), this.$d = y2.set(d, Math.min(this.$D, y2.daysInMonth())).$d;
        } else
          $2 && this.$d[$2](l2);
        return this.init(), this;
      }, m2.set = function(t2, e2) {
        return this.clone().$set(t2, e2);
      }, m2.get = function(t2) {
        return this[O.p(t2)]();
      }, m2.add = function(r2, h2) {
        var d2, $2 = this;
        r2 = Number(r2);
        var l2 = O.p(h2), y2 = function(t2) {
          var e2 = w($2);
          return O.w(e2.date(e2.date() + Math.round(t2 * r2)), $2);
        };
        if (l2 === f)
          return this.set(f, this.$M + r2);
        if (l2 === c)
          return this.set(c, this.$y + r2);
        if (l2 === a)
          return y2(1);
        if (l2 === o)
          return y2(7);
        var M3 = (d2 = {}, d2[s] = e, d2[u] = n, d2[i] = t, d2)[l2] || 1, m3 = this.$d.getTime() + r2 * M3;
        return O.w(m3, this);
      }, m2.subtract = function(t2, e2) {
        return this.add(-1 * t2, e2);
      }, m2.format = function(t2) {
        var e2 = this, n2 = this.$locale();
        if (!this.isValid())
          return n2.invalidDate || $;
        var r2 = t2 || "YYYY-MM-DDTHH:mm:ssZ", i2 = O.z(this), s2 = this.$H, u2 = this.$m, a2 = this.$M, o2 = n2.weekdays, f2 = n2.months, h2 = function(t3, n3, i3, s3) {
          return t3 && (t3[n3] || t3(e2, r2)) || i3[n3].slice(0, s3);
        }, c2 = function(t3) {
          return O.s(s2 % 12 || 12, t3, "0");
        }, d2 = n2.meridiem || function(t3, e3, n3) {
          var r3 = t3 < 12 ? "AM" : "PM";
          return n3 ? r3.toLowerCase() : r3;
        }, l2 = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: a2 + 1, MM: O.s(a2 + 1, 2, "0"), MMM: h2(n2.monthsShort, a2, f2, 3), MMMM: h2(f2, a2), D: this.$D, DD: O.s(this.$D, 2, "0"), d: String(this.$W), dd: h2(n2.weekdaysMin, this.$W, o2, 2), ddd: h2(n2.weekdaysShort, this.$W, o2, 3), dddd: o2[this.$W], H: String(s2), HH: O.s(s2, 2, "0"), h: c2(1), hh: c2(2), a: d2(s2, u2, true), A: d2(s2, u2, false), m: String(u2), mm: O.s(u2, 2, "0"), s: String(this.$s), ss: O.s(this.$s, 2, "0"), SSS: O.s(this.$ms, 3, "0"), Z: i2 };
        return r2.replace(y, function(t3, e3) {
          return e3 || l2[t3] || i2.replace(":", "");
        });
      }, m2.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, m2.diff = function(r2, d2, $2) {
        var l2, y2 = O.p(d2), M3 = w(r2), m3 = (M3.utcOffset() - this.utcOffset()) * e, g2 = this - M3, v2 = O.m(this, M3);
        return v2 = (l2 = {}, l2[c] = v2 / 12, l2[f] = v2, l2[h] = v2 / 3, l2[o] = (g2 - m3) / 6048e5, l2[a] = (g2 - m3) / 864e5, l2[u] = g2 / n, l2[s] = g2 / e, l2[i] = g2 / t, l2)[y2] || g2, $2 ? v2 : O.a(v2);
      }, m2.daysInMonth = function() {
        return this.endOf(f).$D;
      }, m2.$locale = function() {
        return D[this.$L];
      }, m2.locale = function(t2, e2) {
        if (!t2)
          return this.$L;
        var n2 = this.clone(), r2 = S(t2, e2, true);
        return r2 && (n2.$L = r2), n2;
      }, m2.clone = function() {
        return O.w(this.$d, this);
      }, m2.toDate = function() {
        return new Date(this.valueOf());
      }, m2.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, m2.toISOString = function() {
        return this.$d.toISOString();
      }, m2.toString = function() {
        return this.$d.toUTCString();
      }, M2;
    }(), T = _.prototype;
    return w.prototype = T, [["$ms", r], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", f], ["$y", c], ["$D", d]].forEach(function(t2) {
      T[t2[1]] = function(e2) {
        return this.$g(e2, t2[0], t2[1]);
      };
    }), w.extend = function(t2, e2) {
      return t2.$i || (t2(e2, _, w), t2.$i = true), w;
    }, w.locale = S, w.isDayjs = p, w.unix = function(t2) {
      return w(1e3 * t2);
    }, w.en = D[v], w.Ls = D, w.p = {}, w;
  });
})(dayjs_min);
var dayjs = dayjs_min.exports;
var ru$1 = { exports: {} };
(function(module, exports) {
  !function(_, t) {
    module.exports = t(dayjs_min.exports);
  }(commonjsGlobal, function(_) {
    function t(_2) {
      return _2 && typeof _2 == "object" && "default" in _2 ? _2 : { default: _2 };
    }
    var e = t(_), n = "\u044F\u043D\u0432\u0430\u0440\u044F_\u0444\u0435\u0432\u0440\u0430\u043B\u044F_\u043C\u0430\u0440\u0442\u0430_\u0430\u043F\u0440\u0435\u043B\u044F_\u043C\u0430\u044F_\u0438\u044E\u043D\u044F_\u0438\u044E\u043B\u044F_\u0430\u0432\u0433\u0443\u0441\u0442\u0430_\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F_\u043E\u043A\u0442\u044F\u0431\u0440\u044F_\u043D\u043E\u044F\u0431\u0440\u044F_\u0434\u0435\u043A\u0430\u0431\u0440\u044F".split("_"), s = "\u044F\u043D\u0432\u0430\u0440\u044C_\u0444\u0435\u0432\u0440\u0430\u043B\u044C_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440\u0435\u043B\u044C_\u043C\u0430\u0439_\u0438\u044E\u043D\u044C_\u0438\u044E\u043B\u044C_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C_\u043E\u043A\u0442\u044F\u0431\u0440\u044C_\u043D\u043E\u044F\u0431\u0440\u044C_\u0434\u0435\u043A\u0430\u0431\u0440\u044C".split("_"), r = "\u044F\u043D\u0432._\u0444\u0435\u0432\u0440._\u043C\u0430\u0440._\u0430\u043F\u0440._\u043C\u0430\u044F_\u0438\u044E\u043D\u044F_\u0438\u044E\u043B\u044F_\u0430\u0432\u0433._\u0441\u0435\u043D\u0442._\u043E\u043A\u0442._\u043D\u043E\u044F\u0431._\u0434\u0435\u043A.".split("_"), o = "\u044F\u043D\u0432._\u0444\u0435\u0432\u0440._\u043C\u0430\u0440\u0442_\u0430\u043F\u0440._\u043C\u0430\u0439_\u0438\u044E\u043D\u044C_\u0438\u044E\u043B\u044C_\u0430\u0432\u0433._\u0441\u0435\u043D\u0442._\u043E\u043A\u0442._\u043D\u043E\u044F\u0431._\u0434\u0435\u043A.".split("_"), i = /D[oD]?(\[[^[\]]*\]|\s)+MMMM?/;
    function d(_2, t2, e2) {
      var n2, s2;
      return e2 === "m" ? t2 ? "\u043C\u0438\u043D\u0443\u0442\u0430" : "\u043C\u0438\u043D\u0443\u0442\u0443" : _2 + " " + (n2 = +_2, s2 = { mm: t2 ? "\u043C\u0438\u043D\u0443\u0442\u0430_\u043C\u0438\u043D\u0443\u0442\u044B_\u043C\u0438\u043D\u0443\u0442" : "\u043C\u0438\u043D\u0443\u0442\u0443_\u043C\u0438\u043D\u0443\u0442\u044B_\u043C\u0438\u043D\u0443\u0442", hh: "\u0447\u0430\u0441_\u0447\u0430\u0441\u0430_\u0447\u0430\u0441\u043E\u0432", dd: "\u0434\u0435\u043D\u044C_\u0434\u043D\u044F_\u0434\u043D\u0435\u0439", MM: "\u043C\u0435\u0441\u044F\u0446_\u043C\u0435\u0441\u044F\u0446\u0430_\u043C\u0435\u0441\u044F\u0446\u0435\u0432", yy: "\u0433\u043E\u0434_\u0433\u043E\u0434\u0430_\u043B\u0435\u0442" }[e2].split("_"), n2 % 10 == 1 && n2 % 100 != 11 ? s2[0] : n2 % 10 >= 2 && n2 % 10 <= 4 && (n2 % 100 < 10 || n2 % 100 >= 20) ? s2[1] : s2[2]);
    }
    var u = function(_2, t2) {
      return i.test(t2) ? n[_2.month()] : s[_2.month()];
    };
    u.s = s, u.f = n;
    var a = function(_2, t2) {
      return i.test(t2) ? r[_2.month()] : o[_2.month()];
    };
    a.s = o, a.f = r;
    var m = { name: "ru", weekdays: "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435_\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A_\u0432\u0442\u043E\u0440\u043D\u0438\u043A_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0435\u0440\u0433_\u043F\u044F\u0442\u043D\u0438\u0446\u0430_\u0441\u0443\u0431\u0431\u043E\u0442\u0430".split("_"), weekdaysShort: "\u0432\u0441\u043A_\u043F\u043D\u0434_\u0432\u0442\u0440_\u0441\u0440\u0434_\u0447\u0442\u0432_\u043F\u0442\u043D_\u0441\u0431\u0442".split("_"), weekdaysMin: "\u0432\u0441_\u043F\u043D_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043F\u0442_\u0441\u0431".split("_"), months: u, monthsShort: a, weekStart: 1, yearStart: 4, formats: { LT: "H:mm", LTS: "H:mm:ss", L: "DD.MM.YYYY", LL: "D MMMM YYYY \u0433.", LLL: "D MMMM YYYY \u0433., H:mm", LLLL: "dddd, D MMMM YYYY \u0433., H:mm" }, relativeTime: { future: "\u0447\u0435\u0440\u0435\u0437 %s", past: "%s \u043D\u0430\u0437\u0430\u0434", s: "\u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0441\u0435\u043A\u0443\u043D\u0434", m: d, mm: d, h: "\u0447\u0430\u0441", hh: d, d: "\u0434\u0435\u043D\u044C", dd: d, M: "\u043C\u0435\u0441\u044F\u0446", MM: d, y: "\u0433\u043E\u0434", yy: d }, ordinal: function(_2) {
      return _2;
    }, meridiem: function(_2) {
      return _2 < 4 ? "\u043D\u043E\u0447\u0438" : _2 < 12 ? "\u0443\u0442\u0440\u0430" : _2 < 17 ? "\u0434\u043D\u044F" : "\u0432\u0435\u0447\u0435\u0440\u0430";
    } };
    return e.default.locale(m, null, true), m;
  });
})(ru$1);
var ru = ru$1.exports;
class UtilDateInvalidDateArgumentError extends Error {
  constructor(message) {
    super();
    this.message = message;
  }
}
dayjs.locale(ru);
const MS_IN_DAY = 864e5;
const isValidDate = (date) => dayjs(date).isValid();
const dateValidateChecker = (date, message) => {
  if (!isValidDate(date)) {
    throw new UtilDateInvalidDateArgumentError(message);
  }
};
const getSafariDate = (date) => {
  const value = new Date(date);
  const msPerMinute = 6e4;
  const tzOffset = value.getTimezoneOffset() * msPerMinute;
  return new Date(value.getTime() + tzOffset);
};
const checkOldSafari = () => {
  const latestSafariVersion = 14;
  const userAgent = navigator.userAgent.toLowerCase();
  const matchVersion = new RegExp(".*version/([^.]+).*").exec(userAgent);
  const currentVersion = matchVersion !== null ? Number(matchVersion[1]) : latestSafariVersion;
  return /safari/.test(navigator.userAgent.toLowerCase()) && currentVersion < 14 && !/chrome/.test(navigator.userAgent.toLowerCase());
};
const isOldSafari = () => isBrowser() ? checkOldSafari() : false;
const dateFormat = (date, format = "YYYY-MM-DD") => {
  dateValidateChecker(date, "date is invalid");
  const value = isOldSafari() ? getSafariDate(date) : date;
  return dayjs(value).format(format);
};
const differenceInCalendarDays = (dateEnd, dateStart) => {
  dateValidateChecker(dateEnd, "dateEnd is invalid");
  dateValidateChecker(dateStart, "dateStart is invalid");
  const dateLeft = dayjs(dateFormat(dateEnd)).valueOf();
  const dateRight = dayjs(dateFormat(dateStart)).valueOf();
  return Math.floor(Math.abs((dateLeft - dateRight) / MS_IN_DAY));
};
const isBefore = (date, dateToCompare, limit) => {
  dateValidateChecker(date, "date is invalid");
  dateValidateChecker(dateToCompare, "dateToCompare is invalid");
  return dayjs(date).isBefore(dateToCompare, limit);
};
const DEFAULT_PREFIX$1 = "jtnews";
const NEW_USERS_DAYS_FROM_LAST_VISIT = -1;
const LAST_VISIT_DATE_INITIAL = -1;
const CLIENT_DATE_ERROR_DAYS_FROM_LAST_VISIT = -2;
const MAX_LOYAL_USER_DAYS_FROM_LAST_VISIT = 7;
const MAX_AVERAGE_USER_DAYS_FROM_LAST_VISIT = 30;
const FIRST_VISIT_DATE_LOCAL_STORAGE_KEY = "_first_visit_date";
const LOYALTY_USER_LOCAL_STORAGE_KEY = "_loyalty_user";
const LAST_VISIT_DATE_LOCAL_STORAGE_KEY = "_last_visit_date";
class LoyaltyService {
  constructor(_isUserRegion, _date, _prefix = DEFAULT_PREFIX$1) {
    this._isUserRegion = _isUserRegion;
    this._date = _date;
    this._prefix = _prefix;
    this._daysFromLastVisit = 0;
    this._loyalty = "Average";
    this._init();
  }
  get firstVisitDateKey() {
    return `${this._prefix}${FIRST_VISIT_DATE_LOCAL_STORAGE_KEY}`;
  }
  get loyaltyUserKey() {
    return `${this._prefix}${LOYALTY_USER_LOCAL_STORAGE_KEY}`;
  }
  get lastVisitDateKey() {
    return `${this._prefix}${LAST_VISIT_DATE_LOCAL_STORAGE_KEY}`;
  }
  get keys() {
    return {
      firstVisitDateKey: this.firstVisitDateKey,
      loyaltyUserKey: this.loyaltyUserKey,
      lastVisitDateKey: this.lastVisitDateKey
    };
  }
  get loyalty() {
    return this._loyalty;
  }
  get daysFromLastVisit() {
    return this._daysFromLastVisit;
  }
  _init() {
    const firstVisitDate = this._getFirstVisitDate();
    if (firstVisitDate === 0) {
      this._saveFirstVisitDate();
    }
    const { lastVisitDate, loyalty } = this._getSavedLoyaltyData();
    this._saveDaysFromLastVisit(lastVisitDate);
    this._saveLoyaltyStatus(loyalty);
    this._saveLoyaltyDataInLocalStorage();
  }
  _saveLoyaltyStatus(loyalty) {
    const isSameDayOrError = this._daysFromLastVisit === 0 || this._daysFromLastVisit === CLIENT_DATE_ERROR_DAYS_FROM_LAST_VISIT;
    this._loyalty = isSameDayOrError && loyalty ? loyalty : this._calculateLoyalty(loyalty);
  }
  _saveDaysFromLastVisit(date) {
    const calculatedDaysFromLastVisit = differenceInCalendarDays(Date.parse(this._date), date);
    const isBeforeDate = isBefore(date, Date.parse(this._date), "days");
    const daysFromLastVisit = isBeforeDate || calculatedDaysFromLastVisit === 0 && !isBeforeDate ? calculatedDaysFromLastVisit : CLIENT_DATE_ERROR_DAYS_FROM_LAST_VISIT;
    this._daysFromLastVisit = date === LAST_VISIT_DATE_INITIAL ? NEW_USERS_DAYS_FROM_LAST_VISIT : daysFromLastVisit;
  }
  _calculateLoyalty(savedLoyalty) {
    const isNewUser = this._daysFromLastVisit === NEW_USERS_DAYS_FROM_LAST_VISIT || this._daysFromLastVisit === CLIENT_DATE_ERROR_DAYS_FROM_LAST_VISIT;
    if (isNewUser) {
      return this._isUserRegion ? "Average" : "Disloyal";
    }
    if (this._daysFromLastVisit <= MAX_LOYAL_USER_DAYS_FROM_LAST_VISIT) {
      return this._isUserRegion ? "Loyal" : "Average";
    }
    if (this._daysFromLastVisit > MAX_AVERAGE_USER_DAYS_FROM_LAST_VISIT) {
      return this._isUserRegion ? "Average" : "Disloyal";
    }
    if (this._isUserRegion && savedLoyalty === "Loyal") {
      return "Loyal";
    }
    if (this._isUserRegion && savedLoyalty !== "Loyal") {
      return "Average";
    }
    if (!this._isUserRegion && savedLoyalty === "Disloyal") {
      return "Disloyal";
    }
    if (!this._isUserRegion && savedLoyalty !== "Disloyal") {
      return "Average";
    }
    return "Average";
  }
  _saveLoyaltyDataInLocalStorage() {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(this.loyaltyUserKey, this._loyalty);
      window.localStorage.setItem(this.lastVisitDateKey, Date.parse(this._date).toString());
    }
  }
  _saveFirstVisitDate() {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(this.firstVisitDateKey, Date.parse(this._date).toString());
    }
  }
  _getSavedLoyaltyData() {
    if (typeof window !== "undefined") {
      const lastVisitDate = window.localStorage.getItem(this.lastVisitDateKey);
      const loyalty = window.localStorage.getItem(this.loyaltyUserKey);
      return {
        lastVisitDate: Number(lastVisitDate) || LAST_VISIT_DATE_INITIAL,
        loyalty: loyalty || void 0
      };
    }
    return {
      lastVisitDate: LAST_VISIT_DATE_INITIAL,
      loyalty: void 0
    };
  }
  _getFirstVisitDate() {
    if (typeof window !== "undefined") {
      const date = window.localStorage.getItem(this.firstVisitDateKey);
      return Number(date);
    }
    return 0;
  }
}
const DAYS_LIMIT = 30;
const DEFAULT_PREFIX = "jtnews";
const USER_STATUS_LOCAL_STORAGE_KEY = "_page_views_loyalty_status";
const PAGE_VIEWS_DATA_LOCAL_STORAGE_KEY = "_page_views_loyalty_data";
class PageViewsLoyaltyService {
  constructor(_prefix = DEFAULT_PREFIX) {
    this._prefix = _prefix;
    this._date = "";
    this._hasCheckedUserStatus = false;
    this._userStatus = "new_user";
    this._savedPageViewsData = null;
    this._totalViews = 0;
  }
  get userStatusKey() {
    return `${this._prefix}${USER_STATUS_LOCAL_STORAGE_KEY}`;
  }
  get pageViewsDataKey() {
    return `${this._prefix}${PAGE_VIEWS_DATA_LOCAL_STORAGE_KEY}`;
  }
  get keys() {
    return { userStatusKey: this.userStatusKey, pageViewsDataKey: this.pageViewsDataKey };
  }
  getPageViewsLoyalty(date) {
    this._initServiceData(date);
    const { loyalty, views } = this._calcPageViewsLoyalty();
    this._setPageViewsData(this._savedPageViewsData);
    return { loyalty, views };
  }
  _initServiceData(date) {
    this._date = date;
    if (!this._hasCheckedUserStatus) {
      this._updateUserStatus();
    }
    if (this._savedPageViewsData === null) {
      this._savedPageViewsData = this._getSavedPageViewsData();
    }
  }
  _calcPageViewsLoyalty() {
    this._totalViews = this._totalViews > 0 ? this._totalViews + 1 : this._calcTotalViews(this._savedPageViewsData);
    const loyalty = this._userStatus === "new_user" ? "\u041D\u043E\u0432\u044B\u0439" : this._calcLoyaltyStatus(this._totalViews);
    return { loyalty, views: this._totalViews };
  }
  _updateUserStatus() {
    if (typeof window !== "undefined") {
      const savedStatus = window.localStorage.getItem(this.userStatusKey);
      this._userStatus = savedStatus !== null ? "old_user" : "new_user";
      this._saveUserStatusInLocalStorage(this._userStatus);
      this._hasCheckedUserStatus = true;
    }
  }
  _getSavedPageViewsData() {
    if (typeof window !== "undefined") {
      const savedData = window.localStorage.getItem(this.pageViewsDataKey);
      return this._getValidatedPageViewsData(savedData);
    }
    return null;
  }
  _getValidatedPageViewsData(data) {
    let parsedData = {};
    if (data !== null) {
      try {
        parsedData = JSON.parse(data);
      } catch (e) {
        console.error(e);
      }
      for (const key in parsedData) {
        const differenceInDays = differenceInCalendarDays(this._date, key);
        if (differenceInDays > DAYS_LIMIT || Number.isNaN(differenceInDays)) {
          delete parsedData[key];
        }
      }
    }
    return parsedData;
  }
  _calcTotalViews(data) {
    let totalViews = 1;
    if (data !== null) {
      Object.keys(data).forEach((key) => {
        totalViews += data[key];
      });
    }
    return totalViews;
  }
  _calcLoyaltyStatus(viewsCount) {
    let loyaltyStatus = "\u041D\u043E\u0432\u044B\u0439";
    if (viewsCount >= 1 && viewsCount < 4) {
      loyaltyStatus = "\u0421\u043B\u0443\u0447\u0430\u0439\u043D\u044B\u0439";
    } else if (viewsCount >= 4 && viewsCount < 11) {
      loyaltyStatus = "\u0420\u0435\u0434\u043A\u0438\u0439";
    } else if (viewsCount >= 11 && viewsCount < 21) {
      loyaltyStatus = "\u0420\u0435\u0433\u0443\u043B\u044F\u0440\u043D\u044B\u0439";
    } else if (viewsCount >= 21 && viewsCount < 51) {
      loyaltyStatus = "\u041F\u043E\u0441\u0442\u043E\u044F\u043D\u043D\u044B\u0439";
    } else if (viewsCount >= 51 && viewsCount < 121) {
      loyaltyStatus = "\u041B\u043E\u044F\u043B\u044C\u043D\u044B\u0439";
    } else if (viewsCount >= 121 && viewsCount < 251) {
      loyaltyStatus = "\u041E\u0447\u0435\u043D\u044C_\u043B\u043E\u044F\u043B\u044C\u043D\u044B\u0439";
    } else if (viewsCount >= 251) {
      loyaltyStatus = "\u0421\u0432\u0435\u0440\u0445\u043B\u043E\u044F\u043B\u044C\u043D\u044B\u0439";
    }
    return loyaltyStatus;
  }
  _setPageViewsData(data) {
    const date = dateFormat(this._date, "YYYY-MM-DD");
    if (data !== null) {
      const count = data[date] || 0;
      data[date] = count + 1;
    }
    if (typeof window !== "undefined") {
      window.localStorage.setItem(this.pageViewsDataKey, JSON.stringify(data));
    }
  }
  _saveUserStatusInLocalStorage(status) {
    if (typeof window !== void 0) {
      window.localStorage.setItem(this.userStatusKey, status);
    }
  }
}
export { LoyaltyService, PageViewsLoyaltyService };
